import { FilledLetter } from '../Letter';
import { IRowProps } from './types';

export const FilledRow = ({guess, letterSize}: IRowProps) => {
  return <>{
    guess?.letters?.map((letterData, index) => {
      return <FilledLetter key={index} state={letterData.state} letter={letterData.letter} letterIndex={index} letterSize={letterSize} />;
    })
  }</>
}